import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';
import KeywordsTemplate from './KeywordsTemplate';
import { rem } from 'polished';

export const KeywordsStyled = styled(KeywordsTemplate)`
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.grey31};
    font-size: ${({ theme }) => theme.fontSizes.textTiny};
    line-height: ${rem(14)};
    margin: ${rem(20)} 0;
    
    .offer, .payment, .model {
        padding-bottom: ${rem(8)};
    }
    
    .payment {
        &-link {
            background: none;
            border: none;
            padding: 0;
            color: ${({ theme }) => theme.colors.grey31};
            text-decoration: underline;
            cursor: pointer;
        }
        
        &-description {
            padding-right: ${rem(5)};
        }
    }
`;
